import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { apiClient } from "./api/client";
import "./index.css";
import "./jamroomButtons.css";

const APP_TOKEN_KEY = "jamroom_app_token";
const AUTH_ERROR_KEY = "jamroom_auth_error";

// Token bridge init must run before React effects, otherwise `/api/me` may fire before the token is set.
(() => {
  if (typeof window === "undefined") return;
  try {
    const rawHash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : window.location.hash;
    const hashParams = new URLSearchParams(rawHash);
    const tokenFromHash = hashParams.get("access_token");
    const authErrorFromHash = hashParams.get("auth_error");

    if (tokenFromHash) {
      sessionStorage.setItem(APP_TOKEN_KEY, tokenFromHash);
      hashParams.delete("access_token");
      hashParams.delete("auth_error");
    } else if (authErrorFromHash) {
      sessionStorage.setItem(AUTH_ERROR_KEY, authErrorFromHash);
      hashParams.delete("auth_error");
    }

    if (tokenFromHash || authErrorFromHash) {
      const newHash = hashParams.toString();
      const newUrl = `${window.location.pathname}${window.location.search}${newHash ? `#${newHash}` : ""}`;
      window.history.replaceState({}, document.title, newUrl);
    }

    const stored = sessionStorage.getItem(APP_TOKEN_KEY);
    apiClient.setAuthToken(stored || null);
  } catch {
    // ignore
  }
})();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
